export default __webpack_public_path__ + "static/media/gfonts.243f0d50.png";